import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getIsEnabledAddToCartSelector } from 'menus/selectors';
import PrimaryCta from 'base/components/PrimaryCta';
import { getAddToCartLabel } from 'menus/utils/addToCartCta';
import {
  productPreviewHelperSelectorMenuItem,
  productPreviewHelperSelectorCartItem
} from 'menus/reducers/productPreview';
import { ADD_TO_CART } from 'menus/constants/ctaName';

const MenuItemSubmitContainer = ({
  canAddToCart,
  isAddingToCart,
  isUpdatingPreview,
  cartErrors,
  requiredFieldsAreSelected,
  defaultCtaName,
  previewedQuantityExceedsInventory,
  isSoldOut,
  handleClick
}) => {
  // can add to cart
  // indicates that required
  // fields have been selected
  // dollar max hasn't been breached,
  // and that the menu item is
  // is available (the active menu
  // given fulfillment options contains this item)
  // should refactor here to combine these in a selector or
  // or pull out component booleans
  // for can add to cart

  const isDisabled =
    !canAddToCart ||
    isAddingToCart ||
    previewedQuantityExceedsInventory ||
    isSoldOut ||
    isUpdatingPreview ||
    !!cartErrors.length;
  return (
    <PrimaryCta
      disabled={isDisabled}
      handleClick={handleClick}
      type="submit"
      fullWidth
      label={getAddToCartLabel(
        requiredFieldsAreSelected,
        isAddingToCart,
        defaultCtaName,
        isSoldOut
      )}
      dataTestId="menu-item-detail-add-to-cart"
    />
  );
};

MenuItemSubmitContainer.propTypes = {
  canAddToCart: PropTypes.bool,
  isAddingToCart: PropTypes.bool,
  isUpdatingPreview: PropTypes.bool,
  cartErrors: PropTypes.arrayOf(PropTypes.string),
  requiredFieldsAreSelected: PropTypes.bool,
  defaultCtaName: PropTypes.string,
  previewedQuantityExceedsInventory: PropTypes.bool,
  isSoldOut: PropTypes.bool,
  handleClick: PropTypes.func
};

MenuItemSubmitContainer.defaultProps = {
  defaultCtaName: ADD_TO_CART,
  handleClick: () => {}
};

const mapStateToProps = (state, ownProps) => {
  const previewSelector =
    ownProps.formType === 'MENU_ITEM'
      ? productPreviewHelperSelectorMenuItem
      : productPreviewHelperSelectorCartItem;
  return {
    isAddingToCart: state.cart.isFetching,
    cartErrors: state.cart.error,
    ...previewSelector(state),
    ...getIsEnabledAddToCartSelector(state)
  };
};

export default connect(mapStateToProps)(MenuItemSubmitContainer);
